export enum TagsOperationTypes {
    Sum = 0,
    Product = 1
}